module.exports = __webpack_public_path__ + "img/Phot_3__Second_Canal_986_82_239.49afa04d.jpg";